/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import {
  getSponsorshipsFromClient,
  addSponsorshipsToClient,
  getSponsorshipPool as _getSponsorshipPool,
  resendEmail as _resendEmail,
} from '@/services/api/customer/account';
// initial state
const state = {
  sponsored: [],
  message: '',
  pool: 0,
  new: [],
  current: {},
};

// getters
const getters = {
  referrals: (state) => state.sponsored,
  message: (state) => state.message,
  current: (state) => state.current,
  pool: (state) => state.pool,
  new: (state) => state.new,
};

// actions
const actions = {
  addNewEmpty({ commit }) {
    commit('ADD_NEW_EMPTY');
  },
  async getSponsorshipPool({ commit, rootGetters }) {
    const { clientId } = rootGetters['client/clientCredentials'];
    const { data } = await _getSponsorshipPool(clientId);
    commit('SET_VALUE', { pool: data });
  },
  async getSponsorships({ commit, rootGetters }) {
    const client = rootGetters['client/clientCredentials'];
    const { clientId } = client;
    const { data } = await getSponsorshipsFromClient(clientId);
    commit('SET_VALUE', { sponsored: data });
    return data;
  },
  async addSoloReferral({ rootGetters }, sponsorshipId) {
    const client = rootGetters['client/get'];
    await addSponsorshipsToClient(sponsorshipId, [client], '');
  },
  async pushNewSponsorship({ commit, state, rootGetters }) {
    const client = rootGetters['client/clientCredentials'];
    const { clientId } = client;
    const { sponsored } = state;
    const { data } = await addSponsorshipsToClient(clientId, state.new);
    commit('SET_VALUE', { sponsored: data.concat(sponsored) });
    commit('SET_VALUE', { new: [] });
    return data;
  },
  async resendEmail({ state, rootGetters }) {
    const { clientId } = rootGetters['client/clientCredentials'];
    await _resendEmail(clientId, state.current.id);
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
  ADD_NEW_EMPTY(state) {
    state.new.push({
      email: null,
      firstName: null,
      lastName: null,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
